import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BulletinService } from '../bulletin/bulletin.service';

@Injectable({
  providedIn: 'root'
})
export class DataStorageService {

  private url=environment.firebaseConfig.databaseURL;
  constructor(private http:HttpClient,
    private bulletinService:BulletinService) { }

  fetchBulletin(){
    this.http.get<string>(this.url+'/bulletin.json').subscribe(
      res=>{
        this.bulletinService.setBulletin(res);
        console.log(res);
      },
      error=>{
        console.log(error);
      }
    );
  }
}
